import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { DEFAULT_PAGE_NUMBER, DEFAULT_LOAD_MORE } from '../../../../constants';
import { clientProductsRoute } from '../route';

import { clientLoansFilterFormSchema } from './components/ClientLoansFilter/clientLoansFilterFormSchema';

export const clientLoansRoute = createRoute({
	path: '/loans',
	getParentRoute: () => clientProductsRoute,
	component: lazyRouteComponent(
		() => import('./ClientLoansPage'),
		'ClientLoansPage',
	),
	validateSearch: z.object({
		openedLoan: z.string().optional(),
		filter: clientLoansFilterFormSchema.catch({ loanState: 'active' }),
		pageNumber: z.number().prefault(DEFAULT_PAGE_NUMBER),
		loadMore: z.number().prefault(DEFAULT_LOAD_MORE),
	}),
});
